export default "__VITE_ASSET__Di1zDHKZ__"